<template>
    <div>
        <b-button variant="success" size="lg" @click="area_collapse = !area_collapse">
            <span class="block-text">{{ areaTitle }}</span>
            <i :class="$tools.style.classToggle(area_collapse)"></i>
        </b-button>
        <b-collapse id="collapse" v-model="area_collapse" class="mt-2">

            <b-card class="print-card">

                <slot>
                    <!-- Additional Content Here -->
                </slot>
                        
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
export default {
    props: {
        areaTitle: {
            type: String,
            default: 'Collapse Button',
        },
    },
    data () {
        return {
            area_collapse: true,
        }
    },
}
</script>

<style lang="scss" scoped>

// 為了讓浮水印露出來，card 的背景改為透明
.print-card
{
    background-color: transparent;
}

</style>